import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";

// function applyConfigColors(config) {
//   const root = document.documentElement;
//   root.style.setProperty("--app-bar-color", config.appBarColor);
//   root.style.setProperty("--app-bar-bg-color", config.appBarBGColor);
//   root.style.setProperty("--footer-bar-color", config.footerBarColor);
// }
// applyConfigColors(config);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
